import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const tasks = async (data: TasksReqT) => {
  const { pageParam, sellerId } = data;
  return axios.get(Routes.TASKS + "/" + sellerId + `?page=${pageParam ?? 1}`);
};

export const useTasks = (params: TasksReqT) => {
  const { sellerId } = params;
  return useInfiniteQuery({
    queryKey: [Keys.TASKS_QRY, sellerId],
    queryFn: ({ pageParam = 1 }) => tasks({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
